import service from '@/store/services/workshop/checker-service';

const state = {
  list: {},
  checker: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => { 
    state.list = list;
  },
  SET_RESOURCE: (state, checker) => {
    state.checker = checker;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((checker) => { commit('SET_RESOURCE', checker); });
  },


  add({commit, dispatch}, params) {
    return service.add(params)
      .then((checker) => { commit('SET_RESOURCE', checker); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((checker) => { commit('SET_RESOURCE', checker); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  checker: state => state.checker,
  page: state => state.meta.page,
};
 
const checker = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default checker;
